import Vue from 'vue';
import Vuex from 'vuex';
import app from '../../app/app';
import layout from '../../layouts/store/layout';
import user from '../../../users/store/user';
import tickets from '../../../tickets/shared/store/tickets';
import feedbacks from '../../../feedbacks/store/feedbacks';
import APIService from '../domain/api';
import createPersistedState from 'vuex-persistedstate';
import bills from '@/modules/invoicing/store/bills';
import maintenanceReports from '@/modules/reports/maintenance-reports/store/maintenance-reports';
import ticketsDashboard from '@/modules/tickets/dashboard/store/tickets-dashboard';
import contacts from '@/modules/contacts/shared/store/contacts';
import customerManagement from '@/modules/customers/store/customer-management';
import reports from '@/modules/reports/shared/store/reports';
import equipments from '@/modules/equipments/store/equipments';
import infodayco from '@/modules/infodayco/shared/store/infodayco';
const apiService = new APIService();
let cloneDeep = require('lodash.clonedeep');
const modules = {
    app,
    layout,
    tickets,
    user,
    feedbacks,
    bills,
    maintenanceReports,
    ticketsDashboard,
    contacts,
    customerManagement,
    reports,
    equipments,
    infodayco,
};

const EMPTY_UGLY_STATE = {
    // **********  SE LLENA CON TICKETS  ********** //
    tickets: {},
    pdts: {},
    ticketsDayco: {},
    filters: {},
    newTicketInserted: -1,
    pagTickets: {},
    pdtsDayco: {},
    averageFB: {},
    dataCreateTickets: {},
    feedback: {},
    // **********  SE LLENA CON getDirectoryContacts  ********** //
    directoryContacts: [],
    // **********  SE LLENA CON getContactUser  ********** //
    contactUser: {},
    // **********  SE LLENA CON CreateUserStatus  ********** //
    createUserStatus: '',
    // **********  SE LLENA CON getCustomerRolesStatusesResources ********** //
    customerRoles: [],
    userStatuses: [],
    privilegeResources: [],
    privileges: [],
    contactTypes: [],
    // **********  SE LLENA CON getCustomers ********** //
    customers: {},
    // **********  SE LLENA CON getEquipments ********** //
    equipments: {},
    // **********  SE LLENA CON getDataCenterAndBuildings ********** //
    dataCentersAndBuildings: {},
    // **********  SE LLENA CON getParameters ********** //
    parameters: {},
    // **********  SE LLENA CON getUsersWithRol ********** //
    usersWithRol: [],
    // **********  SE LLENA CON validateUsername ********** //
    validUsername: {},
    // **********  SE LLENA CON createRol ********** //
    rolCreated: {},
    // **********  SE LLENA CON UserLogin ********** //
    fileResponse: '',
    //DETALLE PDT
    detailPDT: {},
    // **********  TODAVIA NO SE LLENA  ********** //
    contact: {},
    userPrivileges: {},
    contactDeleted: false,
    daycoGroups: {},
    daycoGroupsMapped: {},
    daycoRoles: {},
    loadingContactForm: true,
    loadingDaycoRoles: true,
    loadingEquipmentForm: true,
    userOptions: [{}],
    resetDirectory: {},
    resetEquipment: false,
    createUser: false,
    resetContactDirectory: {},
    service: {},
    userInfoIsSet: false,
    dataForPasswordRecovery: {},
    readyToSetUserInfo: false,
    customerName: '',
    failedContactTransaction: '',
    failedEquipmentTransaction: '',
    failedPasswordRecoveryTransaction: '',
    failedEquipmentBuildingsAndDatacenterTransaction: '',
    failedCustomerTransaction: '',
    failedRolTransaction: '',
    failedDaycoRolTransaction: '',
    typeOfUser: 'Client',
};
Vue.use(Vuex);

const store = new Vuex.Store({
    state: cloneDeep(EMPTY_UGLY_STATE),
    mutations: {
        resetState(state) {
            Object.assign(state, EMPTY_UGLY_STATE);
        },
        // **********  TICKETS  ********** //
        SET_STATE(state, newState) {
            state.tickets = newState.tickets;
            state.pdts = newState.pdts;
            state.newTicketInserted = newState.newTicketInserted;
            state.pagTickets = newState.pagTickets;
            state.dataCreateTickets = newState.dataCreateTickets;
            state.feedback = newState.feedback;
            state.directoryContacts = newState.directoryContacts;
            state.contactUser = newState.contactUser;
            state.createUserStatus = newState.createUserStatus;
            state.reportInfo = newState.reportInfo;
            state.reports = newState.reports;
            state.contact = newState.contact;
            state.userOptions = newState.userOptions;
            state.tickets = newState.service;
            state.typeOfUser = newState.typeOfUser;
        },
        SET_TICKETS(state, tickets) {
            state.tickets = tickets;
        },
        SET_TICKETS_DAYCO(state, tickets) {
            state.ticketsDayco = tickets;
        },
        SET_PAGINATION_TICKETS(state, tickets) {
            state.pagTickets = tickets;
        },
        SET_DATA_CREATE_TICKETS(state, data) {
            state.dataCreateTickets = data;
        },
        SET_TICKETS_FILTERS(state, filters) {
            state.filters = filters;
        },
        SET_PDT_DETAIL(state, pdtDetail) {
            state.detailPDT = pdtDetail;
        },
        SET_NEW_TICKET_INSERTED(state, id: number) {
            state.newTicketInserted = id;
        },
        SET_DATA_PDT(state, pdts) {
            state.pdts = pdts;
        },
        // ***** USERS ***** //
        SET_CONTACT_INFO(state, contact: any) {
            state.contact = contact;
        },
        SET_FAILED_EQUIPMENT_BUILDINGS_DATA_CENTER_TRANSACTION(
            state,
            failedEquipmentBuildingsAndDatacenterTransaction: any,
        ) {
            state.failedEquipmentBuildingsAndDatacenterTransaction = failedEquipmentBuildingsAndDatacenterTransaction;
        },
        SET_FAILED_CUSTOMER_TRANSACTION(state, failedCustomerTransaction: any) {
            state.failedCustomerTransaction = failedCustomerTransaction;
        },
        SET_FAILED_CONTACT_TRANSACTION(state, failedContactTransaction: any) {
            state.failedContactTransaction = failedContactTransaction;
        },
        SET_FAILED_ROLE_TRANSACTION(state, failedRolTransaction: any) {
            state.failedRolTransaction = failedRolTransaction;
        },
        SET_FAILED_DAYCO_ROLE_TRANSACTION(state, failedDaycoRolTransaction: any) {
            state.failedDaycoRolTransaction = failedDaycoRolTransaction;
        },
        SET_FAILED_PASSWORD_RECOVERY_TRANSACTION(state, failedPasswordRecoveryTransaction: any) {
            state.failedPasswordRecoveryTransaction = failedPasswordRecoveryTransaction;
        },
        SET_CONTACT_DELETED(state, contactDeleted) {
            state.contactDeleted = contactDeleted;
        },
        SET_LOADING_DAYCO_ROLES(state, loadingDaycoRoles) {
            state.loadingDaycoRoles = loadingDaycoRoles;
        },
        SET_LOADING_EQUIPMENT_FORM(state, loadingEquipmentForm) {
            state.loadingEquipmentForm = loadingEquipmentForm;
        },
        SET_RESET_DIRECTORY(state, resetDirectory) {
            state.resetDirectory = resetDirectory;
        },
        SET_RESET_EQUIPMENT(state, resetEquipment) {
            state.resetEquipment = resetEquipment;
        },
        SET_RESET_CONTACT_DIRECTORY(state, resetContactDirectory) {
            state.resetContactDirectory = resetContactDirectory;
        },
        SET_VALID_USERNAME(state, validUsername) {
            state.validUsername = validUsername;
        },
        SET_CUSTOMERS(state, customers) {
            state.customers = customers;
        },
        SET_CUSTOMER_OPTIONS(state, customerOptions) {
            state.customerOptions = customerOptions;
        },
        SET_USER_INFO_IS_SET(state, userInfoIsSet) {
            state.userInfoIsSet = userInfoIsSet;
        },
        SET_READY_TO_SET_USER_INFO(state, readyToSetUserInfo) {
            state.readyToSetUserInfo = readyToSetUserInfo;
        },
        SET_CREATE_USER(state, createUser) {
            state.createUser = createUser;
        },
        SET_USERS_WITH_ROLE(state, usersWithRol) {
            state.usersWithRol = usersWithRol;
        },
        SET_DIRECTORY_CONTACTS(state, directoryContacts) {
            state.directoryContacts = directoryContacts;
        },
        SET_CONTACT_USER(state, contactUser) {
            state.contactUser = contactUser;
        },
        SET_USER_STATUSES(state, userStatuses) {
            state.userStatuses = userStatuses;
        },
        // ***** FILES ***** //
        SET_FILE_NAME(state, fileResponse) {
            state.fileResponse = fileResponse;
        },
        // ***** ROLES AND PRIVILEGES ***** //
        SET_PRIVILEGE_RESOURCES(state, privilegeResources) {
            state.privilegeResources = privilegeResources;
        },
        SET_PRIVILEGES(state, privileges) {
            state.privileges = privileges;
        },
        SET_CUSTOMER_ROLES(state, customerRoles) {
            state.customerRoles = customerRoles;
        },
        SET_ROLE_CREATED(state, rolCreated) {
            state.rolCreated = rolCreated;
        },
        SET_DATA_FOR_PASSWORD_RECOVERY(state, dataForPasswordRecovery) {
            state.dataForPasswordRecovery = dataForPasswordRecovery;
        },
        SET_CUSTOMER_NAME(state, customerName) {
            state.customerName = customerName;
        },
        SET_DAYCO_GROUPS(state, daycoGroups) {
            state.daycoGroups = daycoGroups;
        },
        SET_DAYCO_ROLES(state, daycoRoles) {
            state.daycoRoles = daycoRoles;
        },
        SET_DAYCO_GROUPS_MAPPED(state, daycoGroupsMapped) {
            state.daycoGroupsMapped = daycoGroupsMapped;
        },
        SET_CONTACT_TYPES(state, contactTypes) {
            state.contactTypes = contactTypes;
        },
    },
    actions: {
        setNewState(context, payload) {
            context.commit('SET_STATE', payload);
        },

        // *****  TICKETS  ***** //
        // FIX: MOVER AL NUEVO STORE. SIRVE PARA LA CREACIÓN DE TICKETS
        // setTicketId({ commit }, ticketId: number) {
        //   commit("SET_NEW_TICKET_INSERTED", ticketId);
        // },
        async getPDT(context, payload) {
            await apiService.getDataPDT(payload).then(res => {
                context.commit('SET_DATA_PDT', res.data);
            });
        },
        async getTicketsDayco(context, payload) {
            await apiService.getTicketsDayco(payload).then(res => {
                context.commit('SET_TICKETS_DAYCO', res.data);
            });
        },
        async getFilters(context, payload) {
            await apiService.getFilters().then(res => {
                context.commit('SET_TICKETS_FILTERS', res.data);
            });
        },
        async getTicketsByFilter(context, payload) {
            const company: any = localStorage.getItem('company');
            if (JSON.parse(company).id != -1) {
                await apiService.getTicketsByFilter(payload).then(res => {
                    if (payload.customerid == '') {
                        context.commit('SET_TICKETS_DAYCO', res.data);
                    } else {
                        context.commit('SET_PAGINATION_TICKETS', res.data);
                    }
                });
            }
        },
        async getBill(context, payload) {
            const company: any = localStorage.getItem('company');
            if (JSON.parse(company).id != -1) {
                return apiService
                    .getBill(payload)
                    .then(res => {
                        return res;
                    })
                    .catch(err => {
                        throw new Error(err);
                    });
            }
        },
        async uploadFile(context, payload) {
            await apiService.uploadFile(payload).then(res => {
                context.commit('SET_FILE_NAME', res.data.filename);
            });
        },
        async showPDT(context, payload) {
            await apiService.showPDT(payload).then(res => {
                context.commit('SET_PDT_DETAIL', res.data);
            });
        },
        // *****  PROFILE  ***** //
        updateUserInfo(context, payload) {
            return apiService
                .updateUserInfo(payload)
                .then(res => res)
                .catch(err => err);
        },
        // *****  CONTACTS  ***** //
        async uploadMaintenanceReportFile(context, payload) {
            await apiService.uploadMaintenanceReportFile(payload).then(res => {
                context.commit('SET_FILE_NAME', res.data.filename);
            });
        },
        async getDirectoryContactsWithAdminInfo(context, payload) {
            await apiService
                .getDirectoryContactsWithAdminInfo(payload)
                .then(res => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                    context.commit('SET_DIRECTORY_CONTACTS', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'Directory');
                });
        },
        async getContactUser(context, payload) {
            await apiService
                .getContactUser(payload)
                .then(res => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                    context.commit('SET_CONTACT_USER', res.data.results);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'Contact');
                });
        },
        async createContact(context, payload) {
            await apiService
                .createContact(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'CreateContact');
                });
        },
        async updateContact(context, payload) {
            await apiService
                .updateContact(payload)
                .then((res: any) => {
                    context.commit('SET_CONTACT_INFO', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'UpdateContact');
                });
        },
        async deleteContact(context, payload) {
            await apiService
                .deleteContact(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'DeleteContact');
                });
        },
        async createUserUpdateContact(context, payload) {
            await apiService
                .createUserUpdateContact(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'CreateUserUpdateContact');
                });
        },
        async getCustomerRolesStatusesResourcesPrivileges(context, payload) {
            return await apiService
                .getCustomerRolesStatusesResourcesPrivileges(payload)
                .then(res => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                    context.commit('SET_CUSTOMER_ROLES', res.data.values.customerRoles);
                    context.commit('SET_USER_STATUSES', res.data.values.statuses);
                    context.commit('SET_PRIVILEGE_RESOURCES', res.data.values.resources);
                    context.commit('SET_PRIVILEGES', res.data.values.privileges);
                    context.commit('SET_CONTACT_TYPES', res.data.values.contactTypes);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'ContactFormData');
                });
        },
        async createRol(context, payload) {
            await apiService
                .createRol(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', '');
                    context.commit('SET_ROLE_CREATED', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', 'CreateRol');
                });
        },
        async updateRol(context, payload) {
            await apiService
                .updateRol(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', 'UpdateRol');
                });
        },
        async deleteRol(context, payload) {
            await apiService
                .deleteRol(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', 'DeleteRol');
                });
        },
        async getUsersWithRol(context, payload) {
            await apiService
                .getUsersWithRol(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', '');
                    context.commit('SET_USERS_WITH_ROLE', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', 'ValidateRolToDelete');
                });
        },
        async validateUsername(context, payload) {
            await apiService
                .validateUsername(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_ROLE_TRANSACTION', '');
                    context.commit('SET_VALID_USERNAME', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'ValidateUsername');
                });
        },
        async createUser(context, payload) {
            await apiService
                .createUser(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'CreateContact');
                });
        },
        async updateUser(context, payload) {
            await apiService
                .updateUser(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_CONTACT_TRANSACTION', 'UpdateContact');
                });
        },
        async getCustomers(context, payload) {
            await apiService
                .getCustomers(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_CUSTOMER_TRANSACTION', '');
                    context.commit('SET_CUSTOMERS', res.data);
                })
                .catch(error => {
                    context.commit('SET_FAILED_CUSTOMER_TRANSACTION', 'Customers');
                });
        },
        async sendEmailForPasswordRecovery(context, payload) {
            await apiService
                .sendEmailForPasswordRecovery(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', 'EmailSent');
                });
        },
        async resetPassword(context, payload) {
            await apiService
                .resetPassword(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', 'ResetPassword');
                });
        },
        async getCustomerInfo(context, payload) {
            await apiService
                .getCustomerInfo(payload)
                .then((res: any) => {
                    context.commit('SET_CUSTOMER_NAME', res.data.contact);
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_PASSWORD_RECOVERY_TRANSACTION', 'CustomerInfo');
                });
        },
        async getDaycoRoles(context) {
            await apiService
                .getDaycoRoles()
                .then((res: any) => {
                    context.commit('SET_DAYCO_ROLES', res.data);
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', 'DaycoRoles');
                });
        },
        async getDaycoGroups(context, payload) {
            await apiService
                .getDaycoGroups(payload)
                .then((res: any) => {
                    if (payload) {
                        context.commit('SET_DAYCO_GROUPS_MAPPED', res.data);
                    } else {
                        context.commit('SET_DAYCO_GROUPS', res.data);
                    }
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', 'DaycoGroups');
                });
        },
        async mapDaycoRolAndGroup(context, payload) {
            await apiService
                .mapDaycoRolAndGroup(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', 'Mapping');
                });
        },
        async updateMappingDaycoRolAndGroup(context, payload) {
            await apiService
                .updateMappingDaycoRolAndGroup(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', 'UpdateMapping');
                });
        },
        async deleteDaycoGroup(context, payload) {
            await apiService
                .deleteDaycoGroup(payload)
                .then((res: any) => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', '');
                })
                .catch(error => {
                    context.commit('SET_FAILED_DAYCO_ROLE_TRANSACTION', 'DeleteMap');
                });
        },
        resetState({ commit }) {
            commit('resetState');
        },
    },
    modules: cloneDeep(modules),
    plugins: [createPersistedState()],
});

export default store;
